<template>
    <div class="card shadow mb-3 container-fluid">        
        <div class="card-body inline">
            <button class="btn btn-secondary" @click="goToAbsences">
                {{ $trans.get('__JSON__.Absences') }}
            </button>
            <button v-if="can('absence-new-list')" class="btn btn-secondary ml-1" @click="goToNewAbsences">
                {{ $trans.get('__JSON__.New absences') }}
            </button>
        </div>
        <div class="container-fluid m-1">
            <div class="row">
                <div class="input-group mb-3 col-2 pl-1 pr-0">
                    <span class="material-symbols-outlined icon bg-soft-primary text-primary rounded-circle">
                        calendar_month </span>
                    <input id="pickdate" name="date" autocomplete="off" class="form-control" />
                </div>
                <div class="col-2  pr-0">
                    <select class="form-control" v-model="status_id" name="status" id="status">
                        <option v-for="(name, key) in statuses" :key="key" :value="key">
                            {{ $trans.get("__JSON__." + name) }}
                        </option>
                    </select>
                </div>
    
                <div class="col-2 pr-0">
                    <select class="form-control" v-model="location_id" name="location_id" id="location_id">
                        <option :value="0" selected>
                            {{ $trans.get("__JSON__.All locations") }}
                        </option>
                        <option v-for="item in locations" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-2 pr-0">
                    <select class="form-control" v-model="team_id" name="team_id" id="team_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All teams") }}</option>
                        <option v-for="item in teams" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-2 pr-0">
                    <select class="form-control" v-model="absencetypes_id" name="absencetypes_id" id="absencetypes_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All Absencetypes") }}</option>
                        <option v-for="item in filteredAbsencetypes" :key="item.id" :value="item.id">
                            {{ $trans.get("__JSON__." + item.name) }}
                        </option>
                    </select>
                </div>
                <div class="col-2 pr-0">
                    <select class="form-control" name="with_substitutes" id="with_substitutes" v-model="withSubstitutes">
                        <option v-for="option in withSubstitutesOptions" :key="option.id" :value="option.value">
                            {{ $trans.get("__JSON__." + option.name) }}
                        </option>
                    </select>
                </div>
                <div class="col-6"></div>
                <div class="col-6 text-end d-flex calendar-navigation justify-content-end">
                    <button class="btn btn-sm btn-light d-flex align-items-center justify-content-center" @click="subMonth">
                        <span class="material-symbols-outlined"> keyboard_double_arrow_left </span>
                    </button>
                    <button class="btn btn-sm btn-light d-flex align-items-center justify-content-center" @click="subDay">
                        <span class="material-symbols-outlined"> chevron_left </span>
                    </button>
                    <button class="btn btn-sm btn-light d-flex align-items-center justify-content-center" @click="addDay">
                        <span class="material-symbols-outlined"> chevron_right </span>
                    </button>
                    <button class="btn btn-sm btn-light d-flex align-items-center justify-content-center" @click="addMonth">
                        <span class="material-symbols-outlined"> keyboard_double_arrow_right </span>
                    </button>
                    <add-absence @saved="fetchData()" :hr="hr" :short="true" />
                </div>
            </div>
        </div>
    </div>
    
    <div class="card shadow">
        <div class="card-body">
            <table class="w-100">
                <thead style="z-index: 99">
                    <tr>
                    <th>
                        <div class="row p-0 m-0">
                            <div class="col-2 legend">
                                <div>
                                    <div class="employeetask bg-lila rounded-left-pill rounded-right-pill"
                                        role="button"></div>
                                    <span> {{ $trans.get('__JSON__.Simulate shift plan (Monday)') }} </span>
                                </div>
                                <div>
                                    <div class="employeetask vacation-open rounded-left-pill rounded-right-pill"
                                        role="button">
                                    </div><span> {{ $trans.get('__JSON__.Vacation requested') }} </span>
                                </div>
                                <div>
                                    <div class="employeetask rounded-left-pill rounded-right-pill" role="button"></div>
                                    <span>{{ $trans.get('__JSON__.Vacation granted') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask vacation-granted-unpaid rounded-left-pill rounded-right-pill"
                                        role="button"></div><span>{{ $trans.get('__JSON__.Vacation (unpaid) granted')
                                        }}</span>
                                </div>
                                <div>
                                    <div class="employeetask vacation-half-day rounded-left-pill rounded-right-pill"
                                        role="button">
                                    </div>
                                    <span>
                                        {{ $trans.get('__JSON__.Vacation half day') }}
                                    </span>
                                </div>
                                <div>
                                    <div class="employeetask vacation-flextime rounded-left-pill rounded-right-pill"
                                        role="button">
                                    </div><span>{{ $trans.get('__JSON__.Vacation/special leave') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask special-leave rounded-left-pill rounded-right-pill"
                                        role="button">
                                    </div>
                                    <span> {{ $trans.get('__JSON__.Special leave') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask ill rounded-left-pill rounded-right-pill" role="button">
                                    </div>
                                    <span> {{ $trans.get('__JSON__.sick') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask sick-without-certificate rounded-left-pill rounded-right-pill"
                                        role="button"></div>
                                    <span> {{ $trans.get('__JSON__.sick without certificate') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask others rounded-left-pill rounded-right-pill" role="button">
                                    </div>
                                    <span> {{ $trans.get('__JSON__.other') }}</span>
                                </div>
                                <div>
                                    <div class="employeetask vacation-rejected rounded-left-pill rounded-right-pill"
                                        role="button"></div>
                                    <span> {{ $trans.get('__JSON__.Vacation Rejected') }} </span>
                                </div>
                            </div>
                            <div class="col-10 p-0">
                                <div class="col-12 row p-0 m-0 position-relative mb-1">
                                    <div v-for="month in months" class="overflow-hidden" style="max-height: 1.5rem"
                                        :style="{
                                            width: getMonthWidth(month),
                                        }" :class="{
                                            'bg-soft-dark': month[1] % 2 == 0,
                                        }" :key="month[1]">
                                        {{ $trans.get("__JSON__." + monthnames[month[1] - 1]) }} {{ month[0] }}
                                    </div>
                                </div>
                                <div class="col-12 row p-0 m-0 overflow-hidden">
                                    <div class="col p-0 text-center d-inline-block" v-for="day in days" :class="{
                                        'border-start border-dark': day.getDate() == 1,
                                        'bg-grey': day.getDay() == 0 || day.getDay() == 6,
                                        'bg-soft-today': day.isToday(),
                                        'bg-holiday': isHoliday(day),
                                        'bg-lila': day.getDay() == 1 && team_id > 0
                                    }" :key="day.toString()">
                                        <a :href="'/shifts?team=' +
                                            team_id +
                                            '&year=' +
                                            getYearOfWeek(day) +
                                            '&week=' +
                                            getWeekOfYear(day) +
                                            '&simulation=1' +
                                            (employee_spot_id ? '&employee_id=' + employee_spot_id : '')
                                            " v-if="day.getDay() == 1 && team_id > 0" data-toggle="tooltip"
                                            :title="$trans.get('__JSON__.shift simulation')">
                                            {{ $trans.get("__JSON__." + daynames[day.getDay()]) }}<br />
                                            {{ day.getDate() }}
                                        </a>
                                        <span v-if="day.getDay() != 1 || team_id == 0">
                                            {{ $trans.get("__JSON__." + daynames[day.getDay()]) }}<br />
                                            {{ day.getDate() }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-12 row p-0 m-0">
                                    <div class="col p-0 m-0 text-center d-inline-block pt-1 pb-1 BarChartCell"
                                        v-for="(absencesum, index) in absencesums" style="height: 50px">
                                        <div class="SmallBarChart m-auto">
                                            <div class="SmallBarData" v-for="(absenceDetail, index) in absencesum"
                                                :style="{
                                                    height: getAbsencePercentage(absencesum, index) + '%',
                                                    background: getAbsenceColor(index),
                                                }">
                                                {{ index == 0 ? absenceDetail : "" }}
                                            </div>
                                            <div class="BarChartInfo">
                                                {{ $trans.get("__JSON__.sick") }}:<br />
                                                {{ Math.round(getAbsencePercentage(absencesum, 1)) }}% ({{
                                                absencesum[1]
                                                }}) <br />
                                                {{ $trans.get("__JSON__.vacation") }}:<br />
                                                {{ Math.round(getAbsencePercentage(absencesum, 2)) }}% ({{
                                                absencesum[2]
                                                }}) <br />
                                                {{ $trans.get("__JSON__.other") }}:<br />
                                                {{ Math.round(getAbsencePercentage(absencesum, 3)) }}% ({{
                                                absencesum[3]
                                                }}) <br />
                                                {{ $trans.get("__JSON__.unclear") }}:<br />
                                                {{ Math.round(getAbsencePercentage(absencesum, 4)) }}% ({{
                                                absencesum[4]
                                                }})
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 row p-0 m-0">
                                    <div class="col p-0 text-center" v-for="day in days" :key="day.toString()">
                                        <div v-if="dayTeamevents(day)" class="teamevent" data-bs-html="true" v-tooltip
                                            :title="dayTeamevents(day)">
                                            <span class="material-symbols-outlined  p-1">
                                                event_note
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="position-relative">
                                <template v-for="(day, index) in days">
                                    <div v-if="day.getDay() == 0 ||
                                        day.getDay() == 6 ||
                                        day.getDate() == 1 ||
                                        day.isToday() ||
                                        isHoliday(day)" 
                                        class="position-absolute h-100 elapsed calendar-day-overlay" style="z-index: 10; top: 0" :style="{
                                            left: getDayLeft(index),
                                            width: getDayWidth(),
                                        }" :class="{
                                            'border-start border-dark': day.getDate() == 1,
                                            'bg-soft-dark': (day.getDay() == 0 || day.getDay() == 6) && !isHoliday(day),
                                            'bg-soft-today': day.isToday(),
                                            'bg-holiday': isHoliday(day),
                                        }" :key="day.getMonth() + '-' + day.getDate()">
                                    </div>
                                </template>

                                <div v-for="(employee, index) in filteredEmployees"
                                    class="row employeetaskline grow p-0 m-0"
                                    :class="{ 
                                        'div-striped-bg': index % 2 == 0 && employee.id != this.employee_spot_id, 
                                        'div-bg': index % 2 == 1 && employee.id != this.employee_spot_id, 
                                        'bg-spot': employee.id == this.employee_spot_id, 
                                        'div-substitute-bg': employee.empType == 'substituteemployee',
                                        'expanded': contextMenu.show && selectedAbsence.employee_id == employee.id
                                        }"
                                    :key="employee.id + '_' + employee.empType + '_' + index"
                                    @mouseleave="hideTooltip">                                   
                                    <div class="col-2 border-table-top border-halis-lighter pt-1 pr-0 pl-0 h-100 employeenamecontainer "
                                        style="align-items: top">
                                        <div class="row w-100 container align-items-center m-0">
                                            <!-- <div class="col-1 px-0" role="button" v-if="employeeSubstitutes.find(substitute => substitute.employee_id == employee.id)" >
                                                <span class="material-symbols-outlined" >
                                                    expand_all
                                                </span>
                                            </div> -->
                                            <div class="col-8 px-0 d-flex align-items-center" >
                                                <a :href="'/employees/' + employee.id" class="text-underline-hover text-truncate">{{
                                                    employee.lastname
                                                    }},
                                                    {{ employee.forename }}
                                                </a>
                                                <employee-info :employee_id="employee.id" class="ms-1" /> 
                                                <span
                                                    v-if="employee.employer && employee.employer.shortname != 'HAL'"
                                                    class="material-symbols-outlined ms-1" v-tooltip
                                                    :title="employee.employer.name">
                                                    work_history
                                                </span>
                                            </div>
                                            <div class="col-3 px-0 fs-8 text-end text-primary text-truncate"  data-toggle="tooltip" v-tooltip
                                            :title="$trans.get('__JSON__.days planned / days left')" @mouseout="hideTooltip">
                                                <p class="mb-0">
                                                   {{ employee.vacationdata.daysGranted +  (employee.vacationdata.daysUsed * -1) }} / {{ employee.vacationdata.daysLeft }}
                                                </p> 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-10 border-table-top border-halis-lighter">
                                        <div v-for="(absence, sindex) in employee.absences" class="d-flex absence stamp"
                                            :class="{
                                                'rounded-left-pill': absence.roundleft,
                                                'rounded-right-pill': absence.roundright,
                                                'border border-danger': absence.absence_type_id == 2 && !absence.granted && !absence.team_approved_at && !absence.deleted,
                                                'border border-success': absence.absence_type_id == 2 && !absence.granted && absence.team_approved_at,
                                                'not-interactable': absence.outOfContract || absence.deleted,
                                                'outside-contract-range': absence.outOfContract
                                            }" :role="absence.outOfContract || absence.deleted ? '' : 'button'" :style="{
                                                left: absence.startpercent + '%',
                                                width: absence.endpercent + '%',
                                                'background-color': absenceColor(absence),
                                                'background-image': absenceImage(absence),
                                                'height': absence.half_day ? '40%' : '80%',
                                                'top': absence.half_day && absence.hasAnotherHalfDayAbsence ? '50%' : '3px'
                                            }" v-tooltip :title="getTitle(absence)" :data-id="absence.id" :key="absence.id" @click.stop="absence.outOfContract || absence.deleted ? $event.preventDefault() : openContextMenu($event, absence)">
                                        </div>
                                        <div v-for="(training, tindex) in employee.trainings">
                                           <span
                                                class="material-symbols-outlined rounded-circle iconCircle trainingsymbol"
                                                :style="{ 
                                                    left: training.startpercent + '%', 
                                                    top: '50%', 
                                                    position: 'absolute', 
                                                    'visibility': training.hidden ? 'hidden' : 'visible', 
                                                    'z-index': '90', 
                                                    transform: 'translateY(-50%)' 
                                                }"
                                                v-tooltip :title="training.title" :data-id="training.id"
                                                :key="training.id" 
                                                @mouseout="hideTooltip">
                                                school
                                            </span>
                                        </div>
                                    </div>                                
                                    <!-- <vacation-calendar-substitute-lines v-if="employeeSubstitutes.find(substitute => substitute.employee_id == employee.id)" :substituteEmployees="employeeSubstitutes.filter(substitute => substitute.employee_id == employee.id)" 
                                        :employee_spot_id="employee_spot_id" :absencetypes="absencetypes" 
                                        :rangeStart="new Date(this.startYear, this.startMonth, this.startDay)" 
                                        :rangeEnd="new Date(this.startYear, this.startMonth, this.startDay).addDays(this.numberofdays - 1)"
                                        :numberofdays="this.numberofdays" /> -->
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
    <div v-if="loading" style="position:fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 200; background: black; opacity: 25%;">
        <span class="spinner" style="position:fixed; top: 50%; left: 50%; z-index: 150; width: 4rem; height: 4rem;  border-width: 10px !important; opacity: 100%;"></span>
    </div>
    
    <employeevacationmodal v-if="showVacationModal" :employee="employee"
                                    :selectedAbsence="selectedAbsence" 
                                    :team_id="team_id"
                                    :filteredTeamEvents="filteredTeamEvents"
                                    @hideModal="unshowVacationModal"
                                    @reload="fetchData"
                                    @needSecondApproval="Remind2StepProcess"/>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="twostepgrantinginfo">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h1>{{ $trans.get('__JSON__.Two step granting') }}</h1>
            </div>
            <div class="modal-body">
                <p class="mb-0"> {{ $trans.get('__JSON__.The request just confirmed by your team ok') }}, </p>
                <p class="mb-0"> {{ $trans.get('__JSON__.was only step 1 of the 2 step granting process required for this request') }}. </p>
                <br>
                <p class="mb-0"> {{ $trans.get('__JSON__.Final granting will be given by HR') }}.</p>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeTwoStepGrantingInfo">{{ $trans.get('__JSON__.close') }}</button>
            </div>
            </div>
        </div>
        </div>
    </Teleport>

    <Teleport to="body">
        <div v-if="contextMenu.show">
            <div class="context-menu-backdrop" @click="closeContextMenu"></div>
            <div class="context-menu" id="context-menu" :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }">
                <div class="context-menu-item" v-if="(isTeamlead(selectedAbsence.employee_id) || is('HR | SuperAdmin')) && selectedAbsence.absence_type_id == 2 && selectedAbsence.granted == 0"
                    role="button" @click.stop="reviewVacation(selectedAbsence)">
                    <span class="material-symbols-outlined"> settings </span> {{ $trans.get('__JSON__.Vacation grant or reject') }} 
                </div>
                <div class="context-menu-item" v-if="(((selectedAbsence.absence_type_id == 7 || selectedAbsence.absence_type_id == 3) 
                        && isTeamlead(selectedAbsence.employee_id) && isNotOlderThan7Days(selectedAbsence.end_at)
                        || isInFuture(selectedAbsence.end_at)) && isTeamlead(selectedAbsence.employee_id)
                        || is('HR | SuperAdmin | OperationsManager'))" 
                    role="button" @click.stop="editAbsence(selectedAbsence.id)">
                    <span class="material-symbols-outlined"> edit_square </span> {{ $trans.get('__JSON__.Edit Absence') }}
                </div>
                    <div class="context-menu-item"
                    v-if="selectedAbsence.absence_type_id == 1 && isLessThan3DaysOld(selectedAbsence.end_at) && isTeamlead(selectedAbsence.employee_id) && !isInFuture(selectedAbsence.end_at) && !selectedAbsence.sick_certificate"
                    role="button" @click.stop="prolongAbsence(selectedAbsence.id)">
                    <span class="material-symbols-outlined"> add </span> {{ $trans.get('__JSON__.prolong absence (1 day)') }}
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import axios from "axios";
import { useAbsenceStore } from "../stores/AbsenceStore";
import { DateTime } from "luxon";
// import VacationCalendarSubstituteLines from "./VacationCalendarSubstituteLines.vue";

export default {
    setup() {
        let absenceStore = useAbsenceStore();

        return {
            absenceStore: absenceStore,
        };
    },
    // components: {
    //     VacationCalendarSubstituteLines,
    // },
    name: "VacationCalendar",
    created() {
        this.fetchAbsenceTypes();
        this.fetchTeamleads();
        this.fetchLocations();

        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };

        Date.prototype.isToday = function () {
            const today = new Date();
            return (
                this.getDate() == today.getDate() &&
                this.getMonth() == today.getMonth() &&
                this.getFullYear() == today.getFullYear()
            );
        };

        var date = new Date(this.startdate);
        this.startDay = date.getDate();
        this.startMonth = date.getMonth();
        this.startYear = date.getFullYear();
        this.fetchTeamEvents();
        this.is_init_component_runnable = false;
        this.team_id = this.absenceStore.teamId;
        this.location_id = this.absenceStore.locationId;
        this.status_id = this.absenceStore.statusId;
        //this.absencetype_id = absenceStore.absenceId;
        this.withSubstitutes = this.absenceStore.withSubstitutes;
    },
    props: {
        startdate: String,
        team: String,
        employee_spot: String,
        employee_id: String,
        hr: String,
        teamlead: Object,
    },
    data() {
        return {
            statuses: {
                absent: "Absent",
                all: "All statuses",
            },
            status_id: "all",
            daynames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            monthnames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            startDay: null,
            startMonth: null,
            startYear: null,
            displayRange: "",
            days: [],
            employees: [],
            employeeSubstitutes: [],
            workDays: [],
            holidays: [],
            numberofdays: 40,
            absencetypes: [],
            absencetypes_id: 0,
            teams: [],
            team_id: 0,
            locations: [],
            location_id: 0,
            months: [],
            absencesums: [],
            holidays: [],
            selectedAbsence: null,
            vacationdata: null,
            reason: null,
            flextimehours: null,
            employee: null,
            possibilityReport: '',
            possibilityFaultyWeeks: [],
            employee_spot_id: 0,
            errors: null,
            availableDaysReceived: false,
            teamevents: null,
            showVacationModal: false,
            hover: false,
            withSubstitutes: false,
            withSubstitutesOptions: [{'id': 1, 'value': true, 'name': 'with Substitutes'},
                                    {'id': 2, 'value': false, 'name': 'without Substitutes'}],
            is_init_component_runnable: true,
            loading: false,
            absenceControlRoundLeft: true,
            showButtons: null,
            contextMenu: {
                show: false,
                x: 0,
                y: 0,
            }
        };
    },
    computed: {
        startAt() {
            const date = new Date(this.startYear, this.startMonth, this.startDay);
            return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        },
        endAt() {
            const date = new Date(this.startYear, this.startMonth, this.startDay).addDays(
                this.numberofdays - 1
            );

            return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        },
        filteredEmployees() {
            if (this.absencetypes_id == 0) { 
                return this.employees;
            }
            let filteredEmployees = this.employees.filter((item) => {
                item.absences = item.backupAbsences.filter((absence) => { return (absence.absence_type_id == this.absencetypes_id); })
                return item.absences.length > 0;
            });
            return filteredEmployees;
        },
        filteredAbsencetypes() {
            return this.absencetypes.filter((item) => item.not_manual == 0);
        },
        filteredTeamEvents() {
            if (!this.teamevents) {
                return null;
            }

            // const startDayDate = DateTime.fromFormat(this.startAt, 'yyyy-M-d').toISODate();
            // const endDayDate = DateTime.fromFormat(this.endAt, 'yyyy-M-d').toISODate();
            const startDayDate = new Date(this.startAt);
            const endDayDate = new Date(this.endAt);


            // console.log('filteredTeamEvents, startDayDate: ', startDayDate, ' endDayDate: ', endDayDate);

            if (this.absenceStore.teamId == 0) {
                const dayDateTeamEvents = this.teamevents.filter(element =>
                    new Date(element.start_at).getTime() <= endDayDate.getTime()
                    && startDayDate.getTime() <= new Date(element.end_at).getTime()
                    // DateTime.fromISO(element.start_at).toISODate() <= endDayDate
                    // && startDayDate <= DateTime.fromISO(element.end_at).toISODate()
                );

                if (dayDateTeamEvents.length > 0) {
                    console.log('filteredTeamEvents, dayDateTeamEvents: ', dayDateTeamEvents);
                    return dayDateTeamEvents;
                }
            }
            const dayDateTeamEvents = this.teamevents.filter(element => element.team_id == this.team_id
                && new Date(element.start_at).getTime() <= endDayDate.getTime()
                && startDayDate.getTime() <= new Date(element.end_at).getTime()
                // && DateTime.fromISO(element.start_at).toISODate() <= endDayDate
                // && startDayDate <= DateTime.fromISO(element.end_at).toISODate()
            );

            if (dayDateTeamEvents.length > 0) {
                // console.log('filteredTeamEvents, dayDateTeamEvents: ', dayDateTeamEvents);
                return dayDateTeamEvents;
            }
            return null;
        },
        globalFilteredTeamEvents() {
            if (this.filteredTeamEvents) {
                return this.filteredTeamEvents;
            }
            return null;
        },
    },
    watch: {
        team_id: function (newValue, oldValue) {
            this.absenceStore.teamId = newValue;
            if(this.is_init_component_runnable == true) {
                this.loading = true;
                this.fetchTeamEvents();
                this.initComponent();
            }
        },
        location_id: function (newValue, oldValue) {
            this.absenceStore.locationId = newValue;
            if(this.is_init_component_runnable == true) {
                this.loading = true;
                this.initComponent();
            }
        },
        status_id: function (newValue, oldValue) {
            this.absenceStore.statusId = newValue;
            if(this.is_init_component_runnable == true) {
                this.loading = true;
                this.initComponent();
            }
        },
        absencetypes_id: function (newValue, oldValue) {
            //this.absenceStore.absenceId = newValue;
            // this.initComponent();
        },
        startAt: function (newValue, oldValue) {
            if(this.is_init_component_runnable == true) {
                this.loading = true;
                this.fetchTeamEvents();
            }
        },
        withSubstitutes: function (newValue, oldValue) {
            this.absenceStore.withSubstitutes = newValue;
            if(this.is_init_component_runnable == true) {
                this.loading = true;
                this.initComponent();
            }
        },
    },
    mounted() {
        // Alle Tooltips verstecken!
        $('[data-toggle="tooltip"]').tooltip({trigger : 'hover'});
        $(".tooltip").css('display', 'none');
        this.picker = datepicker("#pickdate", {
            onSelect: (instance, date) => {
                this.varday =
                    date.getFullYear() +
                    "-" +
                    this.pad(date.getMonth() + 1, 2) +
                    "-" +
                    this.pad(date.getDate(), 2);

                this.startDay = date.getDate();
                this.startMonth = date.getMonth();
                this.startYear = date.getFullYear();
                this.initComponent();
            },
            dateSelected: new Date(this.startYear, this.startMonth, this.startDay),
            formatter: (input, date, instance) => {
                input.value =
                    date.getFullYear() +
                    "-" +
                    this.pad(date.getMonth() + 1, 2) +
                    "-" +
                    this.pad(date.getDate(), 2);
            },
            startDay: 1,
        }); 

        if (parseInt(this.team) > 0) {
            this.team_id = parseInt(this.team);
        }

        if (this.employee_spot == '') {
            this.employee_spot_id = this.employee_id;
        } else {
            this.employee_spot_id = this.employee_spot;
        }
        // console.log('mounted(), now calls initComponent');
        this.loading = true;
        this.initComponent();
        this.is_init_component_runnable = true;
        document.addEventListener("click", this.closeContextMenu);
        document.addEventListener("scroll", this.closeContextMenu);
        document.addEventListener("keydown", this.handleKeydown);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeContextMenu);
        document.removeEventListener("scroll", this.closeContextMenu);
        document.removeEventListener("keydown", this.handleKeydown);
    },
    methods: {
        hideTooltip(){
            $(".tooltip").css('display', 'none');
        },
        fetchTeamEvents() {
            var dayStartFrom = DateTime.fromFormat(this.startAt, 'yyyy-M-d').toISODate();
            axios
                .get("/api/teamevents", {
                    params: {
                        datefrom: dayStartFrom,
                    },
                })
                .then((resp) => {
                    this.teamevents = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        to_luxon_ISOdate_fromISO(date) {
            var formattedDate = DateTime.fromISO(date).toISODate();
            return formattedDate;
        },
        to_luxon_ISOdate_fromJSDate(date) {
            var formattedDate = DateTime.fromJSDate(date).toISODate();
            return formattedDate;
        },
        dayTeamevents(day) {
            if (!this.globalFilteredTeamEvents) {
                return null;
            }
            const weekDayDate = DateTime.fromJSDate(day).toISODate();
            var dayTeamEvents = this.globalFilteredTeamEvents.filter(element =>
                weekDayDate >= DateTime.fromISO(element.start_at).toISODate()
                && weekDayDate <= DateTime.fromISO(element.end_at).toISODate());
            if (dayTeamEvents.length > 0) {
                let eventNames = []
                dayTeamEvents.forEach((teamEvent) => eventNames.push(teamEvent.name));
                return eventNames.join('<br>');
            }
            return null;
        },
        getYearOfWeek(day) {
            var calenderday = new Date(day);
            calenderday.setDate(calenderday.getDate() + 3 - (calenderday.getDay() + 6) % 7);
            return calenderday.getFullYear();
        },
        getWeekOfYear(day) {
            var calenderday = new Date(day);
            calenderday.setDate(calenderday.getDate() + 3 - (calenderday.getDay() + 6) % 7);
            var week1 = new Date(calenderday.getFullYear(), 0, 4);
            //console.log("calenderday: " , calenderday);
            return 1 + Math.round(((calenderday.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
        },
        getAbsencePercentage(absencesum, index) {
            const sum = absencesum.reduce((partialSum, a) => partialSum + a, 0);
            if (sum == 0) {
                if (index == 0) {
                    return 100;
                }
                return 0;
            }

            return (100 / sum) * absencesum[index];
        },
        getAbsenceColor(absencetypeId) {
            if (absencetypeId == 0) {
                return "rgb(33, 227, 79)";
            }
            var color = this.absencetypes[absencetypeId - 1].project.color;
            return color;
        },
        fillMonth() {
            this.months = [];

            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            const endDate = startDate.addDays(this.numberofdays - 1);

            var endMonth = endDate.getMonth();
            if (endMonth < startDate.getMonth()) {
                endMonth += 12;
            }

            for (var month = startDate.getMonth(); month <= endMonth; month++) {
                if (month > 11) {
                    this.months.push([this.startYear + 1, month - 11]);
                } else {
                    this.months.push([this.startYear, month + 1]);
                }
            }
        },
        getVisibleDays(year, month) {
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            const endDate = startDate.addDays(this.numberofdays - 1);

            var monthStart = new Date(year, month - 1, 1);
            if (startDate.valueOf() > monthStart.valueOf()) {
                monthStart = new Date(startDate.valueOf());
            }

            var monthEnd = new Date(year, month, 0);
            if (endDate.valueOf() < monthEnd.valueOf()) {
                monthEnd = new Date(endDate.valueOf());
            }
            return this.dateDiffInDays(monthStart, monthEnd);
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

            return Math.floor((utc2 - utc1) / _MS_PER_DAY) + 1;
        },
        getMonthWidth(month) {
            var width = (100 / this.numberofdays) * this.getVisibleDays(month[0], month[1]);
            return width + "%";
        },
        getDayLeft(index) {
            var left = (100 / 12) * 2;
            left += ((100 - left) / this.numberofdays) * index * 0.9995;
            return left + "%";
        },
        getDayWidth() {
            var left = (100 / 12) * 2;
            var width = (100 - left) / this.numberofdays;
            return width + "%";
        },
        absenceImage(absence) {
            if (absence.deleted) return null;

            if (absence.absence_type_id == 1 && absence.sick_certificate == 0) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(204, 0, 0, .7) 15px, rgba(0, 0, 204, .7) 30px)';
            }

            if (absence.absence_type_id != 2) {
                return null;
            }

            if (absence.half_day && absence.special_leave) {
                return 'repeating-linear-gradient(-90deg, transparent, transparent 15px, rgba(0, 0, 255, .7) 15px, rgba(255, 0, 0, .7) 30px)';
            }

            if (absence.team_approved_at) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255, 127, 0, .7) 15px, rgba(255, 127, 0, .7) 30px)';
            }

            if (!absence.granted) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255, 0, 0, .7) 15px, rgba(255, 0, 0, .7) 30px)';
            }

            if (absence.half_day && absence.special_leave) {
                return 'repeating-linear-gradient(-90deg, transparent, transparent 15px, rgba(0, 0, 255, .7) 15px, rgba(255, 0, 255, .7) 30px)';
            }

            if (absence.special_leave) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(235, 163, 247, .7) 15px, rgba(235, 163, 247, .7) 30px)';
            }

            if (absence.half_day && absence.from_flextime) {
                return 'repeating-linear-gradient(-90deg, transparent, transparent 15px, rgba(0, 0, 255, .7) 15px, rgba(0, 255, 0, .7) 30px)';
            }

            if (absence.from_flextime) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(0, 255, 0, .7) 15px, rgba(0, 255, 0, .7) 30px)';
            }

            if (absence.half_day && absence.unpaid) {
                return 'repeating-linear-gradient(-90deg, transparent, transparent 15px, rgba(0, 0, 255, .7) 15px, rgba(100, 100, 100, .7) 30px)';
            }

            if (absence.unpaid) {
                return 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(100, 100, 100, .7) 15px, rgba(100, 100, 100, .7) 30px)';
            }

            if (absence.half_day) {
                return 'repeating-linear-gradient(-90deg, transparent, transparent 15px, rgba(0, 0, 255, .7) 15px, rgba(0, 0, 255, .7) 30px)';
            }

            return null;
        },
        absenceColor(absence) {
            //console.log(absence);
            if (absence.deleted) return "rgba(150, 150, 150)";
            const absencetypes = this.absencetypes.filter(
                (absencetype) => absence.type?.id == absencetype.id
            );
            return absencetypes[0].project.color;
        },
        getTitle(absence) {          
            if(absence.type) {
                var absenceName = this.$trans.get('__JSON__.' + absence.type.name);
            }

            if (absence.type.name == 'other') {
                absenceName = absence.project?.name;
            }

            if (absence.special_leave) {
                absenceName = this.$trans.get('__JSON__.Special leave');
            }

            if (absence.half_day) {
                if (absence.second_half) {
                    absenceName += ' / ' + this.$trans.get('__JSON__.Half day') + ' / ' + this.$trans.get('__JSON__.Second half of shift');
                }
                else {
                    absenceName += ' / ' + this.$trans.get('__JSON__.Half day') + ' / ' + this.$trans.get('__JSON__.First half of shift');
                }
            }

            if (absence.unpaid) {
                absenceName += ' / ' + this.$trans.get('__JSON__.Unpaid vacation');
            }

            if (absence.from_flextime) {
                absenceName += ' / ' + this.$trans.get('__JSON__.From flextime');
            }

            if (absence.team_approved_at) {
                absenceName += ' / ' + this.$trans.get('__JSON__.Teamlead approved');
            }

            if (absence.outOfContract) {
                absenceName += ' / ' + this.$trans.get('__JSON__.Reserved');
            }

            if (absence.deleted) {
                absenceName += ' / ' + this.$trans.get('__JSON__.Rejected');
            }

            absenceName += " " +
                this.formatDateTime(absence.start_at) +
                " - " +
                this.formatDateTime(absence.end_at);

            return absenceName;
        },
        formatDateTime(date) {
            return (
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate() +
                " " +
                this.pad(date.getHours(), 2) +
                ":" +
                this.pad(date.getMinutes(), 2)
            );
        },
        formatDateForApiCall(date) {
            return (
                date.getDate() + '.' + (date.getMonth() + 1).toString().padStart(2, "0") + '.' + date.getFullYear()
            );
        },
        initComponent() {
            this.days = [];
            this.displayRange = this.startAt + " - " + this.endAt;
            var date = new Date(Date.UTC(this.startYear, this.startMonth, this.startDay));

            for (var index = 0; index < this.numberofdays; index++) {
                this.days.push(new Date(date.valueOf()));
                date = date.addDays(1);
            }
            this.fillMonth();
            this.fetchData();
            // this.fetchTeamEvents();
            this.fetchHolidays();
        },
        dayClass(date) {
            var result = this.absenceDays.filter(this.filterDate(date, "intime"));
            if (result.length > 0) {
                return result[0].project.name.substring(0, 7);
            }

            result = this.absences.filter(this.filterDate(date, "start_at"));
            if (result.length > 0) {
                return result[0].type.name;
            }

            result = this.holidays.filter(this.filterDate(date, "day"));
            if (result.length > 0) {
                return result[0].name;
            }

            return null;
        },
        fetchData() {
            axios
                .get("/api/absences/employee", {
                    params: {
                        start_at: this.startAt,
                        end_at: this.endAt,
                        team_id: this.team_id,
                        location_id: this.location_id,
                        status_id: this.status_id,
                        withSubstitutes: this.withSubstitutes,
                    },
                })
                .then((resp) => {
                    var rangeStart = new Date(this.startYear, this.startMonth, this.startDay);
                    var rangeEnd = new Date(this.startYear, this.startMonth, this.startDay).addDays(
                        this.numberofdays - 1
                    );

                    console.log(resp.data);

                    Object.entries(resp.data.absencesum).forEach((elem) => {
                        var date = new Date(elem[0]);
                        if (date.getDay() == 0 || date.getDay() == 6) {
                            elem[1][1] = 0;
                        }
                    });
                    this.absencesums = resp.data.absencesum;
                    //console.log("fetch resp" , resp.data.employees);
                    resp.data.employees.forEach((employee) => {
                        var employeeAbsenceDates = [];

                        if(employee.vacation_requests) {
                            employee.vacation_requests.forEach((vacation) => {
                                employee.absences.push({
                                    id: vacation.id,
                                    start_at: new Date(vacation.start_at),
                                    end_at: new Date(vacation.end_at).setHours(23, 59, 59, 999),
                                    absence_type_id: vacation.absence_type_id,
                                    granted: vacation.granted,
                                    special_leave: vacation.special_leave,
                                    half_day: vacation.half_day,
                                    second_half: vacation.second_half,
                                    from_flextime: vacation.from_flextime,
                                    unpaid: vacation.unpaid,
                                    team_approved_at: vacation.team_approved_at,
                                    outOfContract: false,
                                    deleted: true,
                                    type: {
                                        name: "Vacation"
                                    }

                                });
                            });
                        }

                        employee.absences.forEach((absence) => {
                            absence.start_at = new Date(absence.start_at);
                            absence.end_at = new Date(absence.end_at);

                            absence.hasAnotherHalfDayAbsence = false;

                            var checkDate = absence.start_at.getMonth() + '-' + absence.start_at.getDate();
                            if (employeeAbsenceDates.indexOf(checkDate) === -1) {
                                employeeAbsenceDates.push(checkDate);
                            } else {
                                absence.hasAnotherHalfDayAbsence = true;
                            }

                            absence.roundleft = true;
                            absence.roundright = true;

                            if (absence.start_at.getTime() <= rangeStart.getTime()) {
                                absence.startpercent = 0;
                                if (absence.start_at.getTime() < rangeStart.getTime()) {
                                    absence.roundleft = false;
                                }
                            }

                            if (absence.start_at.getTime() > rangeStart.getTime()) {
                                absence.startpercent =
                                    (((absence.start_at.getTime() - rangeStart.getTime()) /
                                        (1000 * 3600 * 24) / this.numberofdays) *
                                    100);
                            }

                            if (absence.end_at.getTime() >= rangeEnd.getTime()) {
                                absence.endpercent = 100 - absence.startpercent;
                                const absenceEndDate = new Date(absence.end_at.getFullYear(), absence.end_at.getMonth(), absence.end_at.getDate());
                                const rangeEndDate = new Date(rangeEnd.getFullYear(), rangeEnd.getMonth(), rangeEnd.getDate());
                                if (absence.end_at.getTime() > rangeEnd.getTime() && absenceEndDate > rangeEndDate) {
                                    absence.roundright = false;
                                }
                            } else if (absence.end_at.getTime() > rangeStart.getTime()) {
                                absence.endpercent =
                                    ((absence.end_at.getTime() - rangeStart.getTime()) /
                                        (1000 * 3600 * 24) /
                                        this.numberofdays) *
                                    100 -
                                    (absence.startpercent);
                            }

                            // Highlight absences that are out of contract 
                            if(employee.vacationdata.lastContractDates){
                                const contractEnd = employee.vacationdata.lastContractDates?.end ? 
                                    new Date(employee.vacationdata.lastContractDates.end) : null;
                                const absenceEnd = new Date(absence.end_at);
                                absenceEnd.setHours(0, 0, 0, 0);

                                if (absence.absence_type_id == 2 && absence.granted == 0 && contractEnd && contractEnd.getTime() < absenceEnd.getTime()) { 
                                    absence.outOfContract = true;
                                }
                            }
                        });

                        employee.backupAbsences = [...employee.absences];
                        //console.log("bis hierhin: " , employee);
                        if(employee.trainings){
                            //console.log("employee training: ", employee.training);
                            employee.trainings.forEach((training) => {
                                training.start_at = new Date(training.start_at);
    
                                if (training.start_at.getTime() <= rangeStart.getTime()) {
                                    training.hidden = true;
                                }
    
                            if (training.start_at.getTime() > rangeStart.getTime()) {
                                // Create a date object for the start of the training day
                                let trainingDateOnly = new Date(training.start_at);
                                trainingDateOnly.setHours(6, 0, 0, 0);                                
                                
                                training.startpercent =
                                    (((trainingDateOnly.getTime() - rangeStart.getTime()) /
                                        (1000 * 3600 * 24) / this.numberofdays) * 100);
                            }
    
                            });
                        }
                    });
                    this.employees = resp.data.employees;
                    this.loading = false;
                    // console.log("fetch data durch");
                    //this.employeeSubstitutes = resp.data.employeeSubstitutes;
                  
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchAbsenceTypes() {
            axios
                .get("/api/absencetypes", {
                    params: {
                        start: this.weekstart,
                        end: this.weekend,
                    },
                })
                .then((resp) => {
                    this.absencetypes = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchTeamleads() {
            axios
                .get("/api/employees/0/shiftleads", {})
                .then((resp) => {
                    this.teams = resp.data;
                    if (this.teams.length == 1) {
                        this.team_id = this.teams[0].id;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchLocations() {
            axios
                .get("/api/locations", {})
                .then((resp) => {
                    this.locations = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchHolidays() {
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            const endDate = startDate.addDays(this.numberofdays - 1);

            axios
                .get("/api/holidays", {
                    params: {
                        start_at: this.formatDate(startDate),
                        end_at: this.formatDate(endDate),
                    },
                })
                .then((resp) => {
                    this.holidays = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        isHoliday(day) {
            const formatedDate = this.formatDate(day);

            const holiday = this.holidays.find((element) => {
                if (element.day == formatedDate) {
                    return true;
                }
            });

            if (holiday) {
                return true;
            }
            return false;
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        subDay() {
            this.startDay--;
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            this.startYear = startDate.getFullYear();
            this.startMonth = startDate.getMonth();
            this.startDay = startDate.getDate();
            this.loading = true;
            this.initComponent();
        },
        addDay() {
            this.startDay++;
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            this.startYear = startDate.getFullYear();
            this.startMonth = startDate.getMonth();
            this.startDay = startDate.getDate();
            this.loading = true;
            this.initComponent();
        },
        subMonth() {
            this.startMonth--;
            if (this.startMonth == 0) {
                this.startMonth = 12;
                this.startYear--;
            }
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            this.startYear = startDate.getFullYear();
            this.startMonth = startDate.getMonth();
            this.startDay = startDate.getDate();
            this.loading = true;
            this.initComponent();
        },
        addMonth() {
            this.startMonth++;
            if (this.startMonth == 13) {
                this.startMonth = 1;
                this.startYear++;
            }
            const startDate = new Date(this.startYear, this.startMonth, this.startDay);
            this.startYear = startDate.getFullYear();
            this.startMonth = startDate.getMonth();
            this.startDay = startDate.getDate();
            this.loading = true;
            this.initComponent();
        },
        pad(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length - size);
        },
        editAbsence(id) {
            this.emitter.emit('edit-absence', { 'id': id })
            // location.href = "/absences/" + id + "/edit";
        },
        prolongAbsence(id) {
            if (confirm(this.$trans.get("__JSON__.prolong absence (1 day)") + "?")) {
                axios
                    .post("/api/absences/" + id + "/addday", {})
                    .then((resp) => {
                        console.log('prolongAbsence(), now calls initComponent');
                        this.initComponent();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            }
        },
        reviewVacation(absence) {
            this.employee = this.employees.find(element => { return element.id == absence.employee_id });
            this.selectedAbsence = absence;
            this.showVacationModal = true;
        },
        isLastMonth(date) {
            var lastMonthStart = new Date();
            lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
            lastMonthStart.setDate(1);
            lastMonthStart.setHours(0);
            lastMonthStart.setMinutes(0);
            lastMonthStart.setSeconds(0);
            if (lastMonthStart.getTime() < date.getTime()) {
                return true;
            }
            return false;
        },
        isInFuture(date) {
            var now = new Date();
            now.setDate(now.getDate() - 1);
            if (now.getTime() < date.getTime()) {
                return true;
            }
            return false;
        },
        isLessThan3DaysOld(date) {
            var now = new Date();
            now.setDate(now.getDate() - 3);
            if (now.getTime() < date.getTime()) {
                return true;
            }
            return false;
        },
        isNotOlderThan7Days(date) {
            var now = DateTime.now().minus({ days: 7 }).toISODate();
            if (now < DateTime.fromJSDate(date).toISODate()) {
                return true;
            }
            return false;
        },
        isTeamlead(employee_id) {
            return this.teamlead.includes(employee_id);
        },
        goToAbsences() {
            let myNewPathname = "/absences"
            window.location.href = decodeURIComponent(myNewPathname);
        },
        goToNewAbsences() {
            let myNewPathname = " /vacations/new";
            window.location.href = decodeURIComponent(myNewPathname);
        },
        unshowVacationModal() {
            this.showVacationModal = false;
        },
        Remind2StepProcess() {
            console.log("Remind2StepProcess() called");
            $('#twostepgrantinginfo').modal({ backdrop: 'static', keyboard: false });
            $('#twostepgrantinginfo').modal('show');
        },
        closeTwoStepGrantingInfo() {
            $('#twostepgrantinginfo').modal('hide');
        },
        /* handleMouseOver(absence) {
            if (absence.originalRoundRight === undefined) {
                absence.originalRoundRight = absence.roundright;
            }
            absence.roundright = false;
            this.absenceControlRoundLeft = false;
        },
        handleMouseLeave(absence) {
            absence.roundright = absence.originalRoundRight !== undefined ? 
                absence.originalRoundRight : true;
            this.absenceControlRoundLeft = true;
        }, */
        openContextMenu(event, absence) {
            this.selectedAbsence = absence;
            this.contextMenu.show = true;
            
            this.$nextTick(() => {
                const menuWidth = $('#context-menu').outerWidth();
                const menuHeight = $('#context-menu').outerHeight();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                const mouseX = event.clientX;
                const mouseY = event.clientY;
                
                if (mouseX + menuWidth > viewportWidth) {
                    this.contextMenu.x = mouseX - menuWidth;
                } else {
                    this.contextMenu.x = mouseX;
                }

                if (mouseY + menuHeight > viewportHeight) {
                    this.contextMenu.y = mouseY - menuHeight;
                } else {
                    this.contextMenu.y = mouseY;
                }
            });
        },
        closeContextMenu() {
            this.contextMenu.show = false;
        },
        handleKeydown(event) {
            if (event.key === "Escape" && this.contextMenu.show) {
                this.closeContextMenu();
            }
        },
    },
};
</script>

<style scoped>
.active {
  background: green;
}

.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 200;
  min-width: 200px;
  padding: 4px 0;
}

.context-menu-item {
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #333;
  transition: background-color 0.2s ease;
}

.context-menu-item:hover {
  background-color: #f5f5f5;
}

.context-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199;
  background: transparent;
}
</style>
